import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import VolunteerWorkSearchResultItem from './Item';
import NoResults from './NoResults';

import './style.scss';

const VolunteerWorkSearchResults = ({ data }) => {
  const { t } = useTranslation();

  const [items, setItems] = useState([]);
  const currentData = useRef(null);

  useEffect(() => {
    if (!data || typeof data.results === 'undefined') return;

    const currentPageNumber = data.results.hits.page.pageNumber;
    const dataChanged = JSON.stringify(currentData.current) !== JSON.stringify(data);

    if (dataChanged) {
      currentData.current = data;

      if (items.length === 0 || currentPageNumber === 0) {
        setItems([...data.results.hits.items]);
      } else {
        setItems([...items, ...data.results.hits.items]);
      }
    }
  }, [data, currentData]);

  return (
    <div className="VolunteerWorkResults">
      {items.length === 0 && (
        <NoResults />
      )}
      {items.length > 0 && (
        <span className="VolunteerWorkResults__title">{t('results_title')}</span>
      )}
      {items.map((item) => {
        return (
          <VolunteerWorkSearchResultItem
            key={item.id}
            item={item}
          />
        );
      })}
    </div>
  );
};

export default VolunteerWorkSearchResults;
